// === WEBSITE CONFIGURATION === //
// Edit this file to customize your child's website easily!

const WEBSITE_CONFIG = {
    // === PERSONAL INFORMATION === //
    child: {
        name: "Deiwat Vattian",           // Full name displayed on homepage
        nickname: "Kunjunnni",              // Short name for navigation/casual use
        age: 6,                        // Current age
        birthDate: "2018-12-13",       // Format: YYYY-MM-DD (for future birthday features)
        favoriteColor: "#FF6B9D",      // Hex color code for personal touch
        bio: "Welcome to my cosmic world of planets, letters, and numbers! Join me as I explore the universe and learn amazing things! 🚀🪐",
        funFact: "I love planets, alphabets, and counting to 100!",
        dream: "To become an astronaut and explore all the planets!"
    },

    // === CONTACT INFORMATION === //
    contact: {
        email: "hello@littlestar.com",           // Contact email (preferably parent's)
        location: "Creative Town, Imagination Land", // City, State (keep general for privacy)
        parentEmail: "parent@example.com",       // Parent's email for form submissions
        allowComments: true,                     // Enable/disable comment features
        moderateComments: true                   // Require parent approval for comments
    },

    // === SOCIAL MEDIA LINKS === //
    social: {
        youtube: {
            enabled: false,                      // Set to true when ready
            url: "https://youtube.com/@littlestar",
            displayName: "My Videos"
        },
        instagram: {
            enabled: false,
            url: "https://instagram.com/littlestar",
            displayName: "My Photos"
        },
        tiktok: {
            enabled: false,
            url: "https://tiktok.com/@littlestar",
            displayName: "Fun Videos"
        },
        pinterest: {
            enabled: false,
            url: "https://pinterest.com/littlestar",
            displayName: "My Ideas"
        }
    },

    // === WEBSITE APPEARANCE === //
    theme: {
        primaryColor: "#4169E1",        // Space blue (Royal Blue)
        secondaryColor: "#9370DB",      // Cosmic purple 
        accentColor: "#FFD700",         // Golden star color
        fontFamily: "Fredoka",          // Main heading font
        bodyFont: "Nunito",             // Body text font
        animations: true,               // Enable magical animations
        darkMode: false,                // Start in light mode
        darkModeEnabled: true,          // Enable dark mode toggle
        reducedMotion: false            // Accessibility option
    },

    // === PHOTO MANAGEMENT === //
    photos: {
        // Photo storage method: 'local', 'icloud', 'google', 'cloudinary', 'placeholder'
        storageMethod: 'local',
        
        // Enable placeholder photos when no real photos exist
        usePlaceholderPhotos: true,
        
        // For local storage (recommended for privacy)
        localPath: './assets/photos/',
        
        // For iCloud shared albums (public links)
        icloudAlbums: {
            family: "https://www.icloud.com/sharedalbum/#B0...", // Replace with your album link
            school: "https://www.icloud.com/sharedalbum/#B0...",
            hobbies: "https://www.icloud.com/sharedalbum/#B0...",
            special: "https://share.icloud.com/photos/0c2dvMZglrydZaIjxUTYKcUDQ"
        },
        
        // For Google Photos shared albums
        googlePhotos: {
            family: "https://photos.app.goo.gl/...", // Replace with your album link
            school: "https://photos.app.goo.gl/...",
            hobbies: "https://photos.app.goo.gl/...",
            special: "https://photos.app.goo.gl/..."
        },
        
        // Image optimization settings
        optimization: {
            quality: 85,                // JPEG quality (1-100)
            maxWidth: 1200,            // Max width for large images
            thumbnailSize: 300,        // Thumbnail dimensions
            lazyLoading: true          // Enable lazy loading
        }
    },

    // === CONTENT SECTIONS === //
    sections: {
        albums: {
            enabled: true,
            title: "📸 My Photo Albums",
            subtitle: "Capturing magical moments and memories!"
        },
        creations: {
            enabled: true,
            title: "🎨 My Amazing Creations", 
            subtitle: "Art, crafts, and creative projects I've made!"
        },
        adventures: {
            enabled: true,
            title: "🌟 My Adventures",
            subtitle: "Exciting places I've been and things I've done!"
        },
        shop: {
            enabled: true,
            title: "🛍️ My Little Shop",
            subtitle: "Special creations available for friends and family!",
            comingSoon: true           // Set to false when ready to sell
        },
        blog: {
            enabled: false,            // Future feature
            title: "📝 My Stories",
            subtitle: "Tales from my adventures and creative journey!"
        }
    },

    // === STATISTICS === //
    stats: {
        photosCount: 50,              // Update as you add photos
        artworksCount: 25,            // Update as you add art
        adventuresCount: 15,          // Update as you add adventures
        autoUpdate: false             // Set to true to auto-count from folders
    },

    // === ADVANCED FEATURES === //
    features: {
        analytics: false,             // Google Analytics (when older)
        searchFunction: false,        // Photo/content search
        downloadPhotos: true,         // Allow photo downloads
        shareButtons: true,           // Social sharing
        printFriendly: true,          // Print-optimized pages
        multiLanguage: false,         // Future: multiple languages
        accessibility: {
            screenReader: true,       // Screen reader support
            highContrast: false,      // High contrast mode
            keyboardNav: true,        // Keyboard navigation
            altText: true            // Alt text for images
        }
    },

    // === PARENTAL CONTROLS === //
    safety: {
        moderateComments: true,       // Require approval for comments
        hidePersonalInfo: true,       // Hide sensitive details
        watermarkPhotos: false,       // Add watermark to photos
        restrictSharing: false,       // Limit social sharing
        privateSections: [],          // Array of sections requiring password
        emergencyContact: "parent@example.com"
    }
};

// === ALBUM CONFIGURATION === //
const ALBUM_CONFIG = {
    family: {
        title: "👨‍👩‍👦 Family Adventures",
        description: "Fun times with my favorite people!",
        coverPhoto: "family-cover.jpg",
        sortOrder: "date_desc",        // newest first
        allowComments: true,
        featured: true                 // Show on homepage
    },
    school: {
        title: "🎒 School Days", 
        description: "Learning and playing with friends!",
        coverPhoto: "school-cover.jpg",
        sortOrder: "date_desc",
        allowComments: true,
        featured: true
    },
    hobbies: {
        title: "🎯 My Hobbies",
        description: "Things I love to do!",
        coverPhoto: "hobbies-cover.jpg", 
        sortOrder: "date_desc",
        allowComments: true,
        featured: true
    },
    special: {
        title: "✨ Special Moments",
        description: "Birthdays, holidays & celebrations!",
        coverPhoto: "special-cover.jpg",
        sortOrder: "date_desc", 
        allowComments: true,
        featured: true
    }
};

// === PHOTO METADATA TEMPLATE === //
const PHOTO_TEMPLATE = {
    // Copy this structure for each photo
    id: 1,                           // Unique number
    filename: "photo.jpg",           // File name
    title: "Amazing Day",            // Photo title
    description: "We had so much fun!", // Photo description
    date: "2024-01-15",             // Date taken (YYYY-MM-DD)
    location: "Park",               // Where it was taken
    tags: ["fun", "family"],        // Keywords for searching
    album: "family",                // Which album it belongs to
    featured: false,                // Show on homepage
    public: true,                   // Visible to visitors
    allowDownload: true,            // Can visitors download
    photographer: "Mom"             // Who took the photo
};

// Export configuration for use in other files
if (typeof module !== 'undefined' && module.exports) {
    module.exports = { WEBSITE_CONFIG, ALBUM_CONFIG, PHOTO_TEMPLATE };
}

// Make available globally in browser
if (typeof window !== 'undefined') {
    window.WEBSITE_CONFIG = WEBSITE_CONFIG;
    window.ALBUM_CONFIG = ALBUM_CONFIG;
    window.PHOTO_TEMPLATE = PHOTO_TEMPLATE;
}
